// The server-side window for a register's list read — put the result in the
// query key. null = whole history; else the ISO instant rows must be received
// on/after. The cutoff is fixed at mount (one key per visit, not one per
// render, so the read never chases the clock). Rule: src/lib/historyWindow.ts.
import { useMemo, useState } from 'react'
import { historyCutoffIso, serverWindowFrom } from '@/lib/historyWindow'

export function useHistoryWindow(showAllHistory: boolean, fromFilter: string): string | null {
  const [cutoffIso] = useState(() => historyCutoffIso())
  return useMemo(
    () => serverWindowFrom(showAllHistory, fromFilter, cutoffIso),
    [showAllHistory, fromFilter, cutoffIso],
  )
}
